import { Avatar0 } from "@/screens/profile-screen/edit/assets/Avatar0"
import { Avatar1 } from "@/screens/profile-screen/edit/assets/Avatar1"
import { Avatar2 } from "@/screens/profile-screen/edit/assets/Avatar2"
import { Avatar3 } from "@/screens/profile-screen/edit/assets/Avatar3"
import { Avatar4 } from "@/screens/profile-screen/edit/assets/Avatar4"
import { Avatar5 } from "@/screens/profile-screen/edit/assets/Avatar5"
import { Avatar6 } from "@/screens/profile-screen/edit/assets/Avatar6"
import { Avatar7 } from "@/screens/profile-screen/edit/assets/Avatar7"
import { Avatar8 } from "@/screens/profile-screen/edit/assets/Avatar8"
import { Avatar9 } from "@/screens/profile-screen/edit/assets/Avatar9"
import { Avatar10 } from "@/screens/profile-screen/edit/assets/Avatar10"
import { Avatar11 } from "@/screens/profile-screen/edit/assets/Avatar11"
import { Avatar12 } from "@/screens/profile-screen/edit/assets/Avatar12"
import { Avatar13 } from "@/screens/profile-screen/edit/assets/Avatar13"
import { Avatar14 } from "@/screens/profile-screen/edit/assets/Avatar14"
import { Avatar15 } from "@/screens/profile-screen/edit/assets/Avatar15"
import { Avatar16 } from "@/screens/profile-screen/edit/assets/Avatar16"
import { Avatar17 } from "@/screens/profile-screen/edit/assets/Avatar17"
import { Avatar18 } from "@/screens/profile-screen/edit/assets/Avatar18"
import { Avatar19 } from "@/screens/profile-screen/edit/assets/Avatar19"
import { Avatar20 } from "@/screens/profile-screen/edit/assets/Avatar20"
import { Avatar21 } from "@/screens/profile-screen/edit/assets/Avatar21"
import { Avatar22 } from "@/screens/profile-screen/edit/assets/Avatar22"
import { Avatar23 } from "@/screens/profile-screen/edit/assets/Avatar23"
import { Avatar24 } from "@/screens/profile-screen/edit/assets/Avatar24"
import { Avatar25 } from "@/screens/profile-screen/edit/assets/Avatar25"
import { Avatar26 } from "@/screens/profile-screen/edit/assets/Avatar26"
import { Avatar27 } from "@/screens/profile-screen/edit/assets/Avatar27"
import { Avatar28 } from "@/screens/profile-screen/edit/assets/Avatar28"
import { Avatar29 } from "@/screens/profile-screen/edit/assets/Avatar29"
import { Avatar30 } from "@/screens/profile-screen/edit/assets/Avatar30"
import { Avatar31 } from "@/screens/profile-screen/edit/assets/Avatar31"
import { Avatar32 } from "@/screens/profile-screen/edit/assets/Avatar32"
import { Avatar33 } from "@/screens/profile-screen/edit/assets/Avatar33"
import { Avatar34 } from "@/screens/profile-screen/edit/assets/Avatar34"
import { Avatar35 } from "@/screens/profile-screen/edit/assets/Avatar35"
import { Avatar36 } from "@/screens/profile-screen/edit/assets/Avatar36"
import { Avatar37 } from "@/screens/profile-screen/edit/assets/Avatar37"
import { Avatar38 } from "@/screens/profile-screen/edit/assets/Avatar38"
import { Avatar39 } from "@/screens/profile-screen/edit/assets/Avatar39"
import { Avatar40 } from "@/screens/profile-screen/edit/assets/Avatar40"
import { Avatar41 } from "@/screens/profile-screen/edit/assets/Avatar41"
  
const Avatars = { Avatar0, Avatar1, Avatar2, Avatar3, Avatar4, Avatar5, Avatar6, Avatar7, Avatar8, Avatar9, Avatar10, Avatar11, Avatar12, Avatar13, Avatar14, Avatar15, Avatar16, Avatar17, Avatar18, Avatar19, Avatar20, Avatar21, Avatar22, Avatar23, Avatar24, Avatar25, Avatar26, Avatar27, Avatar28, Avatar29, Avatar30, Avatar31, Avatar32, Avatar33, Avatar34, Avatar35, Avatar36, Avatar37, Avatar38, Avatar39, Avatar40, Avatar41 }

export { Avatars }
